import type { IDataSchemaDefinitions } from '@tarslib/types/lib/dataSchema';
import { createContext } from 'use-context-selector';

export const DataSchemaContext = createContext<IDataSchemaDefinitions>({});
